<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <MovementResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import MovementResourceList from '@/components/Movement/ResourceList.vue';

export default defineComponent({
  name: 'Index',
  components: {
    MovementResourceList,
  },
});
</script>

<style scoped lang="scss">

</style>
